import { Link } from 'react-router-dom'
import { Attribution } from '../components/Attribution.js'

/**
 * The page for a URL that is not one of ours.
 *
 * Served with a real 404 by the server, which is the half that matters: until
 * this existed every misspelling and every probe answered 200 with the home
 * screen, so a crawler saw one page duplicated across the whole origin.
 *
 * The two links out are the two places somebody who mistyped actually wants:
 * a lobby code goes in on the home screen, and everything else is the rules.
 */
export function NotFound() {
  return (
    <main className="shell notfound">
      <header className="rules__head">
        <h1 className="rules__title">No such page</h1>
        <p className="rules__sub">
          That link does not lead anywhere here. A lobby that has finished is gone for good, and a
          code is only four characters, so it is worth a second look at the one you were given.
        </p>
      </header>

      <p className="home__hint">
        <Link to="/">Start or join a game</Link>
      </p>
      <p className="home__hint">
        <Link to="/rules">How to play</Link>
      </p>

      <Attribution />
    </main>
  )
}
